import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ShoppingCartOutlined,
  SafetyOutlined,
  AuditOutlined,
  RiseOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ShoppingCartOutlined />,
  1: <SafetyOutlined />,
  2: <AuditOutlined />,
  3: <DollarOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("pms");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-pms-section dev-pms-benefits-section">
      <div className="dev-pms-section-inner">
        <h2 className="dev-section-h2 dev-pms-section-h2">
          <span className="dev-pms-section-h2-icon dev-pms-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-pms-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-pms-benefit-card">
              <div className="dev-pms-benefit-left">
                <span className="dev-pms-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-pms-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-pms-benefit-body">
                <div className="dev-pms-benefit-title">{item.title}</div>
                <div className="dev-pms-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
